/*!
 * WASA Particle Physics v10 -- pure wander, no scroll animation.
 *
 * 400 particles drift gently and continuously like dust suspended in
 * still air. Each particle follows a unique, low-frequency path made
 * from two summed sinusoids per axis. No scroll-driven motion: the
 * particles are document-anchored, so normal scrolling already moves
 * them with the page (which is what the user sees as "the dust is
 * still there"). No flicks, no launches, no spring-back.
 */
(function () {
  'use strict';

  if (window.__wasaPhysicsBoot) return;
  window.__wasaPhysicsBoot = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── tunables ── */
  var WANDER_AMP_X = 22;        // base horizontal amplitude (px)
  var WANDER_AMP_Y = 26;        // base vertical amplitude (px)
  var WANDER_RATE  = 0.00095;   // global time->phase scale -- visible motion
                                // without crossing into "jittery" territory

  var particles = [];
  var startTime = 0;

  function init() {
    var els = document.querySelectorAll('.wasa-sp');
    if (!els.length) return;

    startTime = performance.now();

    particles = Array.from(els).map(function (el, i) {
      el.style.animation = 'none';

      var ampX    = WANDER_AMP_X * (0.7 + ((i * 13) % 11) / 30);
      var ampY    = WANDER_AMP_Y * (0.7 + ((i * 17) % 11) / 30);
      var phaseAx = (i * 0.9173) % (Math.PI * 2);
      var phaseAy = (i * 1.4413) % (Math.PI * 2);
      var phaseBx = (i * 2.1789) % (Math.PI * 2);
      var phaseBy = (i * 0.5527) % (Math.PI * 2);
      var speedA  = 0.55 + ((i * 7)  % 13) / 28;
      var speedB  = 0.31 + ((i * 11) % 13) / 28;

      // Gold shimmer: preserve any size-class blur, add per-particle brightness pulse.
      var isGold       = el.classList.contains('wasa-sp-gold');
      var blurAmount   = el.classList.contains('wasa-sp-xxl') ? 0.8
                       : el.classList.contains('wasa-sp-xl')  ? 0.4
                       : el.classList.contains('wasa-sp-l')   ? 0.2 : 0;
      var blurStr      = blurAmount > 0 ? 'blur(' + blurAmount + 'px) ' : '';
      var shimmerPhase = (i * 1.7321) % (Math.PI * 2);
      var shimmerSpeed = 0.42 + ((i * 5) % 9) / 30;

      return {
        el           : el,
        ampX         : ampX,
        ampY         : ampY,
        phaseAx      : phaseAx,
        phaseAy      : phaseAy,
        phaseBx      : phaseBx,
        phaseBy      : phaseBy,
        speedA       : speedA,
        speedB       : speedB,
        isGold       : isGold,
        blurStr      : blurStr,
        shimmerPhase : shimmerPhase,
        shimmerSpeed : shimmerSpeed,
      };
    });

    /* Render first frame immediately (so initial positions are set before
       the fade-in starts), then mark the aside as ready so CSS can fade
       it in over 600ms. Avoids the flash of clumped-at-top particles. */
    requestAnimationFrame(function (firstNow) {
      tick(firstNow);
      var aside = document.querySelector('.wasa-bg-decor');
      if (aside) aside.classList.add('is-ready');
    });
  }

  function tick(now) {
    var t = (now - startTime) * WANDER_RATE;

    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];

      var wx = p.ampX * 0.6 * Math.sin(t * p.speedA + p.phaseAx)
             + p.ampX * 0.4 * Math.sin(t * p.speedB * 1.7 + p.phaseBx);
      var wy = p.ampY * 0.6 * Math.cos(t * p.speedA * 0.83 + p.phaseAy)
             + p.ampY * 0.4 * Math.sin(t * p.speedB * 1.3 + p.phaseBy);

      p.el.style.transform =
        'translate(' + wx.toFixed(2) + 'px,' + wy.toFixed(2) + 'px)';

      if (p.isGold) {
        var shimmer = 0.7 + 0.55
          * (0.5 + 0.5 * Math.sin(t * p.shimmerSpeed + p.shimmerPhase));
        p.el.style.filter = p.blurStr + 'brightness(' + shimmer.toFixed(3) + ')';
      }
    }

    requestAnimationFrame(tick);
  }

  function boot() {
    if (document.querySelector('.wasa-sp')) {
      init();
    } else {
      setTimeout(init, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 80); });
  } else {
    setTimeout(boot, 80);
  }
}());
